<div class="wrap">
  <div class="button border-sm">Burgers</div>
  <div class="button border-sm button-selected">Vegans</div>
  <div class="button border-sm">Fast food</div>
  <div class="button border-sm button-disabled">Soups</div>
  <div class="button border-sm">Chicken</div>
</div>
